/*** IMPORTS FROM imports-loader ***/
var define = false;

export function stickyJobSearch() {
  // var windowHeight = window.innerHeight;
  // alert(windowHeight);
  // var logoPosition = $('.hero__logo').offset();
  // alert(logoPosition.top);
  // $(window).scroll(function () {
  //   if ($(this).scrollTop() > 5) {
  //     $("body").addClass("scrolled");
  //   } else {
  //     $("body").removeClass("scrolled");
  //   }
  // });

  var filtersPosition = $('.block-views-exposed-filter-blockjob-search-page-1').offset();
  var filtersHeight = $('.block-views-exposed-filter-blockjob-search-page-1').innerHeight();
  var filtersWidth = $('.block-views-exposed-filter-blockjob-search-page-1 .content').innerWidth();
  // alert(filtersHeight);

  $(window).scroll(function () {
    if ($(this).scrollTop() > filtersPosition.top) {
      $(".block-views-exposed-filter-blockjob-search-page-1 .content").css('width', filtersWidth + 'px');
      $("body").addClass("sticky-job-search");
      $(".view-job-search").css('paddingTop', filtersHeight + 'px');
    } else {
      $("body").removeClass("sticky-job-search");
      $(".view-job-search").css('paddingTop', '0');
      $(".block-views-exposed-filter-blockjob-search-page-1 .content").css('width', '');
    }
  });
}

